module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/blender-e807819f847573e5d88659edcc120718.svg";